import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveLaboratory() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((laboratoryId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = laboratoryId
      ? quarkusApi.put(`/laboratories/${laboratoryId}`, payload, authHeader)
      : quarkusApi.post('/laboratories', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
